var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form',_vm._b({attrs:{"form":_vm.form.fc}},'a-form',_vm.formLayout,false),[_c('prepare-nets',{attrs:{"prepareNetData":_vm.prepareNetData,"type":"guest"}}),_c('prepare-nets-form',{attrs:{"form":_vm.form,"prepareNetData":_vm.prepareNetData,"type":"guest"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }